import React, { useState } from 'react';
import { Award, CheckCircle, AlertCircle, ArrowRight } from 'lucide-react';

export default function MitarbeiterQuiz() {
  const [quizStarted, setQuizStarted] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [showResult, setShowResult] = useState(false);

  // Beispiel-Fragen für das QA-Training
  const questions = [
    {
      question: 'Worauf ist bei einem Ident-Verfahren besonders zu achten?',
      options: [
        'Dass der Hintergrund möglichst bunt ist',
        'Gute Ausleuchtung des Gesichts und des Ausweisdokuments',
        'Das Smartphone muss währenddessen stummgeschaltet sein'
      ],
      correct: 1
    },
    {
      question: 'Wie wird ein Bug-Report idealerweise formuliert?',
      options: [
        '"Die App stürzt ab, macht was dagegen!"',
        'Reproduktionsschritte, erwartetes vs. tatsächliches Verhalten und Gerät-Infos',
        'Nur ein Screenshot reicht völlig aus'
      ],
      correct: 1
    }
  ];

  const handleAnswer = (index) => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setShowResult(true);
    }
  };

  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 max-w-3xl">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-primary">Qualifikation & Training</h1>
        <p className="text-muted-foreground">Sichern Sie sich durch kurze Schulungen Zugang zu besser bezahlten Tests.</p>
      </div>

      {!quizStarted ? (
        <div className="bg-white p-8 rounded-xl border border-border shadow-sm text-center">
          <div className="w-16 h-16 bg-accent/10 text-accent rounded-full flex items-center justify-center mx-auto mb-6">
            <Award className="w-8 h-8" />
          </div>
          <h2 className="text-xl font-bold text-primary mb-4">Basis-Zertifizierung QA</h2>
          <p className="text-secondary mb-8">
            Dieses kurze Modul testet Ihre Kenntnisse im Erstellen von Fehlerberichten (Bug-Reports).
            Es dauert ca. 5 Minuten und schaltet Fintech-Aufträge frei.
          </p>
          <button 
            onClick={() => setQuizStarted(true)}
            className="bg-primary text-white px-8 py-3 rounded-md font-medium hover:bg-secondary transition-colors inline-flex items-center gap-2"
          >
            Modul starten <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      ) : !showResult ? (
        <div className="bg-white p-8 rounded-xl border border-border shadow-sm">
          <div className="flex justify-between items-center mb-6 text-sm font-medium text-muted-foreground">
            <span>Frage {currentQuestion + 1} von {questions.length}</span>
            <span>Modul: Basis-Zertifizierung QA</span>
          </div>
          <h2 className="text-xl font-bold text-primary mb-6">
            {questions[currentQuestion].question}
          </h2>
          <div className="space-y-3">
            {questions[currentQuestion].options.map((option, index) => (
              <button
                key={index}
                onClick={() => handleAnswer(index)}
                className="w-full text-left p-4 border border-border rounded-lg hover:border-accent hover:bg-slate-50 transition-colors text-secondary"
              >
                {option}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <div className="bg-white p-8 rounded-xl border border-border shadow-sm text-center">
          <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-8 h-8" />
          </div>
          <h2 className="text-xl font-bold text-primary mb-4">Herzlichen Glückwunsch!</h2>
          <p className="text-secondary mb-8">
            Sie haben das Modul erfolgreich bestanden. Die neuen Aufträge wurden für Ihr Profil freigeschaltet.
          </p>
          <button 
            onClick={() => {
              setQuizStarted(false);
              setShowResult(false);
              setCurrentQuestion(0);
            }}
            className="bg-primary text-white px-8 py-3 rounded-md font-medium hover:bg-secondary transition-colors"
          >
            Zurück zur Übersicht
          </button>
        </div>
      )}
    </div>
  );
}